import { NodeKey, $getNodeByKey } from 'lexical';
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { InlineFrameNode } from '../nodes/InlineFrameNode';
import { Size } from '../../../lib/Graphics/Dim2';
import EmbeddedMedia from './EmbeddedMedia';

export type VideoProperties =
{
    src: string
    width?: number
    height?: number
}

export function Video({ nodeKey, properties }: { nodeKey: NodeKey; properties?: VideoProperties })
{
    const [editor] = useLexicalComposerContext();
    const initialSize: Size | null = properties?.width && properties?.height
        ? { width: properties.width, height: properties.height }
        : null;
    const src = properties?.src ?? '';
    const handleResizeEnd = (width: number, height: number) =>
    {
        editor.update(() =>
        {
            const node = $getNodeByKey(nodeKey) as InlineFrameNode | null;
            if (node) { node.setSize(width, height); }
        });
    };
    const element =
    <EmbeddedMedia
        nodeKey={nodeKey}
        initialSize={initialSize}
        onSizeCommit={handleResizeEnd}
    >
    {({ mediaRef, style }) => (
        <video
            ref={mediaRef as any}
            src={src}
            style={style}
            controls
        />
    )}
    </EmbeddedMedia>;
    return element;
}